import './App.scss';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import GlobalFooter from './components/GlobalFooter';
import LandingPage from './LandingPage';
import NotFound from './NotFound';
import { COLORS } from './constants/colors';

function App() {
  return (
    <>
      <div style={{ minHeight: '100lvh', display: 'flex', flexDirection: 'column', backgroundColor: COLORS.burgundy[50] }}>
        {/* <GlobalHeader /> */}
        <BrowserRouter>
          <Routes>
            <Route path="/" exact={true} element={<LandingPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </div>
      <GlobalFooter />
    </>
  );
}

export default App;
